import { grey } from '@mui/material/colors';

export const Button = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontFamily: 'Lato, sans-serif',
        fontSize: '16px',
        fontWeight: 600,
        letterSpacing: '.46px',
      },
    },
    variants: [
      {
        props: { variant: 'outlined' },
        style: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
      {
        props: { variant: 'text' },
        style: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
      {
        props: { variant: 'store' },
        style: {
          border: `1px solid ${grey[400]}`,
          backgroundColor: '#ffffff',
          color: grey[600],
          '&:hover': {
            border: `1px solid ${grey[600]}`,
            backgroundColor: grey[200],
            color: grey[600],
          },
          '&:active': {
            border: `1px solid ${grey[900]}`,
            backgroundColor: grey[400],
            color: grey[700],
          },
          '.selected': {
            backgroundColor: grey[100],
            color: grey[600],
          },
        },
      },
      {
        props: { variant: 'metaMask' },
        style: {
          color: grey[700],
          border: `1px solid ${grey[700]}`,
          backgroundColor: '#ffffff',
          '&:hover': {
            backgroundColor: '#f8dbc3',
            color: grey[700],
          },
          '&:active': {
            color: '#f6851b',
            backgroundColor: grey[900],
          },
        },
      },
      {
        props: { variant: 'metaMask', color: 'secondary' },
        style: {
          boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
          border: 'none',
          color: grey[700],
          backgroundColor: '#f8dbc3',
          '&:hover': {
            backgroundColor: '#fbbb80',
          },
        },
      },
      {
        props: { variant: 'stripe' },
        style: {
          color: '#ffffff',
          backgroundColor: '#3581ea',
          '&:hover': {
            backgroundColor: '#1970e9',
          },
        },
      },
    ],
  },
};
